var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPendingIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 800,
  height: 800,
  fill: "currentColor",
  viewBox: "0 0 32 32",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 16,
  r: 2
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 16,
  r: 2
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16 30a14 14 0 1 1 14-14 14.016 14.016 0 0 1-14 14m0-26a12 12 0 1 0 12 12A12.014 12.014 0 0 0 16 4"
})), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z",
  "data-name": "<Transparent Rectangle>",
  style: {
    fill: "none"
  }
}));
export { SvgPendingIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/pendingIcon.svg";